import { render, staticRenderFns } from "./display.vue?vue&type=template&id=0d184379&"
import script from "./display.vue?vue&type=script&lang=js&"
export * from "./display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports